export default "__VITE_ASSET__2dd45ca6__"